import axios from 'axios'


const epdModelSettingURL = '/animalGenetics/epdModelSetting';

export default {
    getEPDsettings: async function(trait) {
        try {
            const res = await axios.get(`/animalGenetics/epdRequiredFieldsSetting/${trait}`)
            return Promise.resolve(res);
        }catch(e) {
            return Promise.reject(e)
        }
    },

    getEPDModelSettings: async function() {
        try {
            const res = await axios.get(epdModelSettingURL);
            return Promise.resolve(res);
        } catch (e) {
            return Promise.reject(e);
        }
    },

    updateEPDModelSettings: async function (modelSetting) {
        try {
            const res = await axios.put(epdModelSettingURL, modelSetting);
            return Promise.resolve(res);
        } catch (e) {
            return Promise.reject(e);
        }
    }
}